// Essential Imports
import { Injectable } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Firebase
import { firestore } from 'firebase/app';
import { AngularFirestore } from '@angular/fire/firestore';
import Timestamp = firestore.Timestamp;

// Services
import { GlobalServices } from '../admin/servicios/globales.services';

// Models
import { Business } from '../admin/modelos/business.model';
import { BusinessDB } from '../admin/modelos/businessdb.model';
import { Rifas } from '../admin/modelos/rifas.model';
import { RifasDB } from '../admin/modelos/rifasdb.model';

@Injectable()
export class RifaService {
  constructor(
    private db: AngularFirestore,
    private global: GlobalServices,
  ) { }

  private eventoActivo: string; // Nombre del evento activo a feria
  private participantes: any[]; // Guardar todos los participantes

  //Extraer el evento activo
  getEvento() {
    return new Promise((resolve, reject) => {
      this.db.collection('eventos', ref => ref.where("activoFeria", "==", true)).valueChanges().pipe().subscribe((snap) => {
        const record = snap.map((item) => {
          return item;
        });

        if (!(Object.keys(record).length)) resolve({ ok: false, record: [] });
        else resolve({ ok: true, record: record });
      }, (e) => { reject(e) });
    });
  }

  //Setear key evento a state
  setEvento(eventoKey: string): void {
    this.eventoActivo = eventoKey;
  }

  // Extraer registros del evento activo a feria (Participantes).
  getParticipantes(): Observable<Business[]> {
    return this.db.collection<BusinessDB>('registros').snapshotChanges().pipe(
      map(actions => actions.filter((a) => {
        if (
          a.payload.doc.data().es_miembro && a.payload.doc.data().asistio &&
          !a.payload.doc.data().es_eliminado && a.payload.doc.data().evento == this.eventoActivo &&
          !a.payload.doc.data().ganador && !a.payload.doc.data().eliminadoRifa) {
          return a.payload.doc.data();
        }
      }).map(a => {
        const _data = a.payload.doc.data();
        const id = a.payload.doc.id;
        const fecha = (_data.fecha as Timestamp).toDate();

        const data: Business = {
          key: id,
          nombre: _data.nombre,
          correo: _data.correo,
          empresa: _data.empresa,
          cargo: _data.cargo,
          telefono: _data.telefono,
          es_miembro: _data.es_miembro,
          fecha: fecha,
          evento: _data.evento,
          asistio: _data.asistio,
          fecha_asistio: new Date,
          es_eliminado: false,
        };

        return data;
      }))
    );
  }

  setParticipantes(participantes: any = []): void {
    this.participantes = participantes;
  }

  getParticipantesRifa(): any[] {
    return this.participantes;
  }

  // Extrayendo ganador
  ganador(participante: any, keyRifa: string) {
    console.log("🚀 ~ GANADOR", participante)
    this.updateGanador(keyRifa, participante);
    this.updateRifas(keyRifa, participante);
  }

  // Modificar registro para identificar que fue ganador de rifa
  async updateGanador(keyRifa: string, registro_business: Business) {
    const data = {
      ganador: true,
      rifa: keyRifa,
    }
    console.log('-----------------------GANADOR---------------------------');
    console.log(`Se realizo cambio a: ${registro_business.nombre} porque fue el ganador`);
    console.log('ganador: ', 'true');
    console.log('--------------------------------------------------');
    this.db.collection('registros').doc(registro_business.key).update(data);
    let dtRes = await this.updateStateDelet(registro_business);
    return dtRes;
  }

  // Extrayendo eliminado
  eliminado(participante: any) {
    const data = {
      eliminadoRifa: true,
    }
    console.log('-----------------------ELIMINADO--------------------------');
    console.log(`Se realizo cambio a: ${participante.nombre} porque fue eliminado`);
    console.log('eliminadoRifa: ', 'false');
    console.log('--------------------------------------------------');
    return this.db.collection('registros').doc(participante.key).update(data);
  }

  // Guardar resultados de rifa
  updateRifas(key, registro) {
    const daata = {
      estado: true,
      ganadorNombre: registro.nombre,
      ganadorKey: registro.key,
      ganadorCorreo: registro.correo,
      ganadorEmpresa: registro.empresa,
      evento: registro.evento,
      fecha: this.global.generateCurrentDate(),
    }

    return this.db.collection('rifas').doc(key).update(daata);
  }

  // Extraer regalos de rifa
  getRifas(): Observable<Rifas[]> {
    return this.db.collection<RifasDB>('rifas').snapshotChanges().pipe(
      map(actions => actions.filter((a) => {
        if (!a.payload.doc.data().estado) {
          return a.payload.doc.data();
        }
      }).map(a => {
        const _data = a.payload.doc.data();
        const id = a.payload.doc.id;

        const data: Rifas = {
          key: id,
          patrocinador: _data.patrocinador,
          urlLogo: _data.urlLogo,
          premio: _data.premio,
          estado: _data.estado,
        };

        return data;
      }))
    );
  }

  // Extraer data para generar Excel
  getRifasExcel(): Observable<Rifas[]> {
    return this.db.collection<RifasDB>('rifas', ref => ref.orderBy('fecha', 'desc')).snapshotChanges().pipe(
      map(actions => actions.filter((a) => {
        if (a.payload.doc.data().estado && a.payload.doc.data().evento == this.eventoActivo) {
          return a.payload.doc.data();
        }
      }).map(a => {
        const _data = a.payload.doc.data();
        const id = a.payload.doc.id;

        const data: Rifas = {
          key: id,
          patrocinador: _data.patrocinador,
          urlLogo: _data.urlLogo,
          premio: _data.premio,
          estado: _data.estado,
          ganadorNombre: _data.ganadorNombre,
          ganadorCorreo: _data.ganadorCorreo,
          ganadorEmpresa: _data.ganadorEmpresa,
          fecha: _data.fecha,
          evento: _data.evento
        };

        return data;
      }))
    );
  }

  async updateStateDelet(registro_business: Business) {
    this.db.collection('registros', ref => ref.where('evento','==',registro_business.evento)).get().subscribe( res => {
      res.forEach( async doc => {
        if (doc.data().eliminadoRifa && !doc.data().ganador){
          await this.db.collection('registros').doc(doc.id).update({eliminadoRifa: false}).then(res => {
            console.log('-----------------------RESTORE--------------------------');
            console.log(`Se realizo cambio a: ${doc.data().nombre} porque fue eliminado`);
            console.log('eliminadoRifa: ', 'false');
            console.log('--------------------------------------------------');
          });
        }
      })
      console.log('SE TERMINO EL FOREACH');
      return true;
    });
  }

}
